import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'

export const SIGNAL_PROVIDER_LIST_SEARCH_PARAM = 'q'

export function useSignalProviderListSearch() {
  const [searchParams, setSearchParams] = useSearchParams()
  const search = searchParams.get(SIGNAL_PROVIDER_LIST_SEARCH_PARAM) ?? ''

  const setSearch = useCallback(
    (value: string) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev)
          if (value) {
            next.set(SIGNAL_PROVIDER_LIST_SEARCH_PARAM, value)
          } else {
            next.delete(SIGNAL_PROVIDER_LIST_SEARCH_PARAM)
          }
          return next
        },
        { replace: true },
      )
    },
    [setSearchParams],
  )

  return { search, setSearch }
}
